import React from "react";
import "./Project.css";
import Nav from "../Nav";


const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  arrows: true,
  dots: true
};

let Project = () => (

  <div>
    <Nav/>
    <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoTec">03 Eco Technologies</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">04 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoVision">05 Eco-Vision</a></p>

            </div>
          </div>
        <div className="col-8">
        <div class="abhead4">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Planning Structure</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>At the Heart of the Global Circular Economy</p>
        <p className="text-justify">Good Morning Bamboo Eco-city  will be located within the Abura Asebu Kwamankese and Mfantsiman Districts Area, about 45 km away from the Cape Coast City Centre. Good Morning Bamboo Eco-city has a land area of 200 Acres and is planned for a population of 10,000 residents. It is bounded by Ajumako Enyan and Ekumfi Districts on the east, Cape Coast and Heman Lower Denkyira on the west, Gulf of Guinea on the south and Assin South on the north. Good Morning Bamboo Eco-city is planned as a compact eco-city.  A good mix of uses, including public amenities and commercial facilities (and hence jobs) are located close to residential areas, similar to how new towns are planned in Singapore.

</p>
        </div>
       
      
     </div>
   </div>
  </div>
)
export default Project;
